/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TopWrapper from "../core/LoginWrapper/TopWrapper";

/* Component imports */
import * as UtilityLg from "../../UtilityLg";
import * as Services from "../../Services/services";
import ConstantsLg from "../../ConstantsLg";
import ContentLg from "../../ContentLg";
import LandingScreen from "./components/LandingScreen/LandingScreen";
import LoginScreen from "./components/LoginScreen/LoginScreen";
import SuccessScreen from "./components/SuccessScreen/SuccessScreen";
import ResetPasswordScreen from "./components/ResetPasswordScreen/ResetPasswordScreen";
import {verifyRecruiterEmail} from "../../Services/services";

/* Style imports */

/*** End Imports ***/

class RecruiterLoginMain extends Component{

    constructor(props){
        super(props);
        this.state = {
            title: ContentLg.SIGNUP_LOGIN,
            showBack: false,
            showClose: true,
            showFooter: true,
            isNextDisabled: false,
            showMessageEmailDirty: false,
            showErrorMessagePasswordMismatch: false,
            showMessagePublicEmailDomain: false,
            btnBackLabel: ContentLg.BTN.BACK,
            btnNextLabel: ContentLg.BTN.NEXT,
            successHeader: null,
            successMsg: null,
            pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LANDING_PAGE,
            emailValidationMsg: ContentLg.MSG.INVALID_EMAIL,
            pswdValidationMsg: null
        };

        this.isEmailValid = true;
        this.isEmailDirty = false;
        this.isPswdValid = true;
        this.isPswdDirty = false;
        this.recEmail = '';
        this.recPassword = '';

        UtilityLg.bindThisToAll(this, "onLandingTxtBxEmailChange", "onLandingNextBtnClick",
            "signUpRecruiter", "onBackClick", "onNextClick", "onTxtBxPswdChange", "onLoginSubmitClick",
            "onForgotPassword", "onResetPswdSubmitClick", "onHeaderLeftBtnClick", "onHeaderRightBtnClick",
            "onTxtBxEmailEnter", "onTxtBxPswdEnter", "onEmailEditClick"
        );
    }

    componentWillMount(){

    }

    componentDidMount(){

    }

    componentWillUnmount(){

    }

    /* Header */
    onHeaderLeftBtnClick = () => {
        const {pageIdentifier} = this.state;

        switch(pageIdentifier) {
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_RESET_PSWD_PAGE:
                this.setState({
                    title: ContentLg.REC_LOGIN_TITLE,
                    showBack : false,
                    showClose: true,
                    showFooter : true,
                    isNextDisabled: false,
                    btnNextLabel: ContentLg.BTN.SEND_EMAIL,
                    pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LOGIN_PAGE
                });
                break;
        }
    };

    onHeaderRightBtnClick = () => {
        const {pageIdentifier} = this.state;

        switch(pageIdentifier) {
            default:
                this.props.onClose();
        }
    };

    onBackClick = () => {
        const {pageIdentifier} = this.state;

        switch (pageIdentifier) {
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LANDING_PAGE:
                this.props.showLoginModalLanding();
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LOGIN_PAGE:
                this.setState({
                    title: ContentLg.SIGNUP_LOGIN,
                    showBack : false,
                    showClose: true,
                    showFooter : true,
                    pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LANDING_PAGE
                });
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_RESET_PSWD_PAGE:
                this.setState({
                    title: ContentLg.REC_LOGIN_TITLE,
                    showBack : false,
                    showClose: true,
                    showFooter : true,
                    isNextDisabled: false,
                    btnNextLabel: ContentLg.BTN.SEND_EMAIL,
                    pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LOGIN_PAGE
                });
                break;
        }
    };

    onNextClick = () => {
        const {pageIdentifier} = this.state;

        switch (pageIdentifier) {
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LANDING_PAGE:
                this.onLandingNextBtnClick();
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LOGIN_PAGE:
                this.onLoginSubmitClick();
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_RESET_PSWD_PAGE:
                this.onResetPswdSubmitClick();
                break;
        }
    };

    /* Landing */
    onLandingTxtBxEmailChange = (value, {isValid, isDirty}) => {
        this.setState({
            showMessagePublicEmailDomain: false
        });
        this.recEmail = value;
        this.isEmailValid = isValid;
        this.isEmailDirty = isDirty;

        const {emailValidationMsg} = this.state;
        if(emailValidationMsg !== ContentLg.MSG.INVALID_EMAIL){
            this.setState({
                emailValidationMsg: ContentLg.MSG.INVALID_EMAIL
            });
        }
    };

    onLandingNextBtnClick = () => {
        window.triggerCkAnalytics("send", "event", "Login/Signup", "Recruiter - Email Entered");
        this.verifyRecruiterEmail();
    };

    onTxtBxEmailEnter = () => {
        this.landingScrnRef.txtBxEmailFocusOut();
        this.verifyRecruiterEmail();
    };

    verifyRecruiterEmail = () => {
        if (ConstantsLg.TALENTPARTNER_EMAIL_REGEX.test(this.recEmail)) {
            console.log(this.recEmail)
            // this.props.history.push("/", {
            //     tp_email: this.recEmail
            // });
        } 
            if(!this.isEmailDirty){
                this.landingScrnRef.validate();
                this.setState({
                    showMessageEmailDirty: true
                });
            }
            else if(this.isEmailValid){
                this.props.toShowOverlay(true);
                Services.verifyRecruiterEmail({
                    email: this.recEmail,
                    onSuccess: (data) => { //onSuccess
                        this.props.toShowOverlay(false);
                        if (data.recruiter_info) { //already existing
    
                            if (data.recruiter_info.verified === 1) { //already verified
                                this.setState({
                                    pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LOGIN_PAGE,
                                    title: ContentLg.REC_LOGIN_TITLE,
                                    btnNextLabel: ContentLg.BTN.LOGIN
                                });
                            } 
                            else {
                                this.setState({
                                    title: "",
                                    showBack : false,
                                    showClose: true,
                                    showFooter : false,
                                    successHeader: ContentLg.REC_SUCCESS_HDR_SIGNUP,
                                    successMsg: ContentLg.REC_SUCCESS_MSG_SIGNUP,
                                    pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_SUCCESS
                                });
                            }
    
                        } 
                        else if (data.is_public_email_domain) {
                            this.landingScrnRef.showTxtBxEmailAsInvalid();
                            this.setState({
                                emailValidationMsg: ContentLg.MSG.PUBLIC_DOMAIN,
                                showMessagePublicEmailDomain: true
                            });
                        } 
                        else {
                            this.signUpRecruiter();
                        }
                    },
                    onFailure: () => { //onFailure
                        this.props.toShowOverlay(false);
                    }
                });
            }
    };

    signUpRecruiter = () => {
        this.props.toShowOverlay(true);
        Services.signUpRecruiter({
            email: this.recEmail,
            onSuccess: (data) => {
                this.props.toShowOverlay(false);
                if (data.signup_info) {
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Recruiter - Verification Link Sent");

                    this.setState({
                        title: "",
                        showBack : false,
                        showClose: true,
                        showFooter : false,
                        successHeader: ContentLg.REC_SUCCESS_HDR_SIGNUP,
                        successMsg: ContentLg.REC_SUCCESS_MSG_SIGNUP,
                        pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_SUCCESS
                    });
                }
            },
            onFailure: () => {
                this.props.toShowOverlay(false);
                /* handle Failure */
            }
        });
    };

    /* Login */
    onTxtBxPswdChange = (value, {isValid, isDirty}) => {
        
        this.recPassword = value;
        this.isPswdValid = isValid;
        this.isPswdDirty = isDirty;
        this.setState({
            pswdValidationMsg: null
        });
    };

    onBlurPassword = (value) => {
        if(!this.isPswdDirty) {

        }
        else if(!this.isPswdValid) {
            this.setState({
                pswdValidationMsg: ContentLg.MSG.INVALID_MIN_PSWD
            });
        }
        else {
            this.setState({
                pswdValidationMsg: null
            });
        }
    };

    onLoginSubmitClick = () => {
        this.loginRecruiter();
    };

    onTxtBxPswdEnter = () => {
        this.loginScrnRef.txtBxPswdFocusOut();
        this.loginRecruiter();
    };

    loginRecruiter = () => {
        if(!this.isPswdDirty){
            this.loginScrnRef.validate();
            return;
        }

        window.triggerCkAnalytics("send", "event", "Login/Signup", "Recruiter - Login Clicked");

        this.props.toShowOverlay(true);

        Services.loginRecruiter({
            email: this.recEmail,
            password: this.recPassword,
            onSuccess: (data)=>{
                this.props.toShowOverlay(false);
                let verification_info = data.login_verification_info;

                if(verification_info.is_verified_user && verification_info.is_password_matched){
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Recruiter - Verified");
                    this.props.showAppLodingView();
                    this.props.onLoginSuccessRecruiter();
                }
                else if(verification_info.is_verified_user && !verification_info.is_password_matched){
                    this.setState({
                        showErrorMessagePasswordMismatch: true
                    });
                    this.loginScrnRef.showTxtBxPswdAsInvalid();
                    this.setState({
                        pswdValidationMsg: ContentLg.MSG.WRONG_PSWD
                    });
                }
            },
            onFailure: ()=>{
                this.props.toShowOverlay(false);
            }
        });
    };

    onEmailEditClick = () => {
        this.setState({
            title: ContentLg.SIGNUP_LOGIN,
            showBack : false,
            showClose: true,
            showFooter : true,
            pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LANDING_PAGE,
            pswdValidationMsg: null
        });
    };

    /* Reset password */
    onForgotPassword = () => {
        this.setState({
            title: ContentLg.RESET_PSWD,
            showBack : false,
            showClose: false,
            showFooter : true,
            isNextDisabled: false,
            btnNextLabel: ContentLg.BTN.SEND_EMAIL,
            pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_RESET_PSWD_PAGE,
            pswdValidationMsg: null
        });
    };

    onResetPswdSubmitClick = () => {
        this.props.toShowOverlay(true);
        Services.resetPassword({
            email: this.recEmail,
            onSuccess: (data)=>{
                this.props.toShowOverlay(false);
                if( data.recruiter_info){ //success
                    this.setState({
                        title: "",
                        showBack : false,
                        showClose: true,
                        showFooter : false,
                        successHeader: ContentLg.REC_SUCCESS_HDR_RESET_PSWD,
                        successMsg: ContentLg.REC_SUCCESS_MSG_RESET_PSWD,
                        pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_SUCCESS
                    });
                }else{

                }
            }
        });
    };

    onClickChangeUserLoginModal = () => {
        this.props.onClickChangeUserLoginModal(ConstantsLg.LOGIN_TYPE.PROFESSIONAL)
    };

    getViewToBeRendered = pageIdentifier => {
        switch (pageIdentifier){
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.LOADING:
                return (<div>Login In progress...</div>);
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LANDING_PAGE:
                const {emailValidationMsg} = this.state;
                return (
                    <LandingScreen
                        ref = {e=>this.landingScrnRef=e}
                        email = {this.recEmail}
                        emailValidationMsg = {emailValidationMsg}
                        onTxtBxEmailChange = {this.onLandingTxtBxEmailChange}
                        onTxtBxEmailEnter = {this.onTxtBxEmailEnter}
                        onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                        showMessageEmailDirty = {this.state.showMessageEmailDirty}
                        showMessagePublicEmailDomain = {this.state.showMessagePublicEmailDomain}
                    />
                );
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_LOGIN_PAGE:
                const {pswdValidationMsg} = this.state;
                return (
                    <LoginScreen
                        ref = {e=>{this.loginScrnRef=e}}
                        email = {this.recEmail}
                        pswdValidationMsg = {pswdValidationMsg}
                        onTxtBxPswdChange = {this.onTxtBxPswdChange}
                        onTxtBxPswdEnter = {this.onTxtBxPswdEnter}
                        onEmailEditClick = {this.onEmailEditClick}
                        onForgotPassword = {this.onForgotPassword}
                        onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                        onClickLoginRecruiter = {this.loginRecruiter}
                        onBlurPassword = {this.onBlurPassword}
                        // showErrorMessagePasswordMismatch = {this.state.showErrorMessagePasswordMismatch}
                    />
                );
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_SUCCESS:
                const {successHeader, successMsg} = this.state;
                return (
                    <SuccessScreen
                        header = {successHeader}
                        message = {successMsg}
                        email = {this.recEmail}
                        onEmailEditClick = {this.onEmailEditClick}
                        onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                    />
                );
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.REC_RESET_PSWD_PAGE:
                return (
                    <ResetPasswordScreen
                        email = {this.recEmail}
                        onClickChangeUserLoginModal = {this.props.onClickChangeUserLoginModal}
                        onClickSendLink = {this.onNextClick}
                        onEmailEditClick = {this.onEmailEditClick}
                    />
                );
            default:
                return;
        }
    };

    onClickCrossIcon = () => {
        this.props.onClickCrossIconForRecruiter();
    };

    render () {
        const {
            title,
            showBack,
            showClose,
            showFooter,
            isNextDisabled,
            pageIdentifier,
            btnBackLabel,
            btnNextLabel
        } = this.state;

        return (
            <TopWrapper
                title = {ContentLg.SIGNUP_LOGIN}
                iconUrl = {ConstantsLg.ICONS.CROSS_ICON}
                showHeaderLftBtn = {true}
                onClickCrossIcon = {this.onClickCrossIcon}
                showHeaderRgtBtn = {true}
                rightBtnClickListener = {this.props.onClose}
            >
                {this.getViewToBeRendered(pageIdentifier)}

            </TopWrapper>
        );
    }
}

RecruiterLoginMain.PropTypes = {
    onLoginSuccess: PropTypes.func.isRequired
};

export default RecruiterLoginMain;


// WEBPACK FOOTER //
// ./src/components/RecruiterLogin/RecruiterLoginMain.js